export enum TransitionState {
  ENTERING = "entering",
  ENTERED = "entered",
  EXITING = "exiting",
  EXITED = "exited",
}

export enum TransitionPhase {
  APPEAR = "appear",
  ENTER = "enter",
  EXIT = "exit",
}

export type TransitionTimeouts = {
  [TransitionPhase.APPEAR]?: number;
  [TransitionPhase.ENTER]?: number;
  [TransitionPhase.EXIT]?: number;
};

export type TransitionClassNames = {
  enter?: string;
  enterActive?: string;
  exit?: string;
  exitActive?: string;
};
